module.exports = __webpack_public_path__ + "img/logo2.7f576ac9.png";